import React, { Component } from 'react';
import { loginSuccess } from '../actions';

class LoginSuccess extends Component {
  componentWillMount() {
    if (window.parent.store) {
      const ticket = location.search.replace(/^\?ticket=/, '');
      window.parent.store.dispatch(loginSuccess(ticket));
    }
  }

  render() {
    return (<div />);
  }
}

export default LoginSuccess;
